import { trackVideoAnalysis } from '../../../utils';
import { API_BASE_URL } from '../../../constants';

export const useYouTubeAPI = () => {
  // API 키를 백엔드에서 안전하게 관리하도록 변경

  // 백엔드를 통해 YouTube 영상 정보 가져오기 (기본)
  const fetchVideoTitle = async (extractedVideoId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/video-info/${extractedVideoId}`);
      const data = await response.json();
      
      if (data.success && data.data) {
        return data.data.title;
      }
      return "";
    } catch (error) {
      console.warn("백엔드 YouTube API 호출 중 오류:", error);
      return "";
    }
  };

  // 백엔드를 통해 YouTube 영상 정보 가져오기 (상세)
  const fetchVideoData = async (extractedVideoId, inputUrl, parseISO8601Duration, setVideoDuration) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/video-info/${extractedVideoId}`);
      const data = await response.json();
      
      if (data.success && data.data) {
        const videoInfo = data.data;
        const videoTitle = videoInfo.title;
        const durationSeconds = videoInfo.duration_seconds || 0;
        
        setVideoDuration(durationSeconds);
        
        console.log(`[분석 시작] 영상: ${videoTitle}, 길이: ${durationSeconds}초 (${Math.round(durationSeconds/60)}분)`);

        // Google Analytics 이벤트 추적
        trackVideoAnalysis(inputUrl.trim(), videoTitle);

        return {
          videoData: { snippet: videoInfo },
          videoTitle,
          durationSeconds
        };
      } else {
        return null;
      }
    } catch (error) {
      console.error("백엔드 YouTube API 호출 중 오류:", error);
      throw error;
    }
  };

  return {
    fetchVideoTitle,
    fetchVideoData
  };
}; 